export const VIDEO_WIDTH_FACTOR = 4 / 4; // eg. 16/9 , 4/3, 4/4
export const VIDEO_HEIGHT_FACTOR = 4 / 4; // eg. 9/16, 3/4, 4/4
